import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";

export type SearchData = ClientInferRequest<
  typeof contract.quoteRequestLines.search
>["query"]["search"];

export type SortData = ClientInferRequest<
  typeof contract.quoteRequestLines.search
>["query"]["sort"];

type SearchDto = ClientInferResponseBody<typeof contract.quoteRequestLines.search>;

export type SearchQuoteRequestLineDto = SearchDto["quoteRequestLines"][number];

export const fetchQuoteRequestLines = async (
  page: number,
  search: SearchData,
  sort: SortData,
): Promise<SearchDto | null> => {
  const response = await api.quoteRequestLines.search.query({
    query: { search, sort, page },
  });

  if (response.status === 200) {
    return response.body;
  }

  return null;
};
